import React, { Component } from 'react'
import { Icon, Button } from 'antd'
import { cpf as CPF } from 'cpf-cnpj-validator'
import Card from '../../../../components/Card'
import css from './index.scss'
import { avatarURLParse } from '../../../../utils/urlParser'
import { toPhoneFormat } from '../../../../utils/numberFormatters'
import Avatar from '../../../../components/Avatar'


class FoundDriversList extends Component {
  state = {}
  handleSelectDriver = (driver) => {
    this.props.onDriverSelect(driver)
  }
  renderDrivers = () => {
    const { drivers } = this.props
    if (drivers && drivers.length && drivers !== 'NOT_FOUND') {
      return drivers.map(driver => (
        <div className={css.itemRow}>
          <div className={css.row} style={{ justifyContent: 'space-between' }}>
            <Avatar
              src={avatarURLParse(driver.profileImage)}
              alt="Motorista"
              noPicture="/assets/icons/profile.svg"
              size="mini"
            />
            <div className={css.column} style={{ marginLeft: 16 }}>
              <span className={css.nameLabel}>{driver.name}</span>
              <span className={css.data}>{CPF.format(driver.cpf)}</span>
            </div>
            <div className={css.row} style={{ marginLeft: 16 }}>
              <Icon type="phone" style={{ marginRight: 8, width: 16, height: 16 }} fill="#7906a9" />
              <span className={css.nameLabel}>{toPhoneFormat(driver.phone)}</span>
            </div>
            <div className={css.column} style={{ marginLeft: 24 }}>
              <Button
                type="primary"
                size="small"
                onClick={() => this.handleSelectDriver(driver)}
              >
                Selecionar
              </Button>
            </div>
          </div>
        </div>
      ))
    }
    return null
  }
  render() {
    return (
      <Card className={css.card}>
        <div className={css.listContainer}>
          {this.renderDrivers()}
        </div>
      </Card>
    )
  }
}

export default FoundDriversList
